export default __webpack_public_path__ + "static/media/AWP_Large.741a8726.svg";